<template>
  <div id="reportes">
    <!-- <div class="separador text-center mt-5 py-5" data-aos="fade-up" data-aos-delay="600">
      <p class="otrafont fXG electrico">Cuestionarios Registrados</p>
    </div> -->

    <div class="container-fluid pt4">
      <!-- <div class="row pb-5">
        <div class="col-12 otrafont fpR electrico">Semana 1</div>
      </div>-->

      <div class="row">
        <div class="col-12">
          <a class="float-right fpR blanco pointer" @click="logout">
            Cerrar Sesión
          </a>
        </div>
      </div>

      <b-tabs content-class="mt-3 row blanco">
        <b-tab title="Usuarios" active>
          <div class>
            <div class="col-12 electrico pt-5 pb-3">
              <span class="otrafont fpR electrico">Usuarios</span> &nbsp;
              <span class="fpR">(Total: {{ users_array.length }})</span>
            </div>
            <div class="col-12">
              <download-excel class="btndescarga" :data="this.users_array">
                <button class="btn btn-danger">Exportar Usuarios</button>
              </download-excel>
            </div>
            <div class="col-12">
              <v-client-table
                :columns="columns_users"
                v-model="users_array"
                :options="options_users"
              ></v-client-table>
            </div>
          </div>
        </b-tab>
        <b-tab title="Cuestionarios">
          <div class>
            <div class="col-12 electrico pt-5 pb-3">
              <span class="otrafont fpR electrico">Cuestionarios</span> &nbsp;
              <span class="fpR">(Total: {{ tickets.length }})</span>
            </div>

            <div class="col-12">
              <download-excel class="btndescarga" :data="this.tickets">
                <button class="btn btn-danger">Exportar Cuestionarios</button>
              </download-excel>
            </div>
            <div class="col-12">
              <v-client-table
                :columns="columns"
                v-model="tickets"
                :options="options"
              >
                <a
                  slot="uri"
                  slot-scope="props"
                  target="_blank"
                  :href="props.row.uri"
                  class="glyphicon glyphicon-eye-open"
                  >Ver</a
                >

                <div
                  slot="name"
                  slot-scope="{
                    row,
                    update,
                    setEditing,
                    isEditing,
                    revertValue,
                  }"
                >
                  <span @click="setEditing(true)" v-if="!isEditing()">
                    <a>{{ row.name }}</a>
                  </span>
                  <span v-else>
                    <input type="text" v-model="row.name" />
                    <button
                      type="button"
                      class="btn btn-info btn-xs"
                      @click="
                        update(row.name);
                        setEditing(false);
                      "
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      class="btn btn-default btn-xs"
                      @click="
                        revertValue();
                        setEditing(false);
                      "
                    >
                      Cancel
                    </button>
                  </span>
                </div>
              </v-client-table>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <Footer></Footer>
    <Glyphicons></Glyphicons>
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 36;
import Footer from "@/components/Footer";
import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import * as fb from "../firebase";
import * as moment from "moment";
import { misionesCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    Footer,
    Glyphicons,
  },
  data() {
    return {
      habilidades: {
        habilidad_0: "Procedimental",
        habilidad_1: "Empático",
        habilidad_2: "Analítico",
        habilidad_3: "Creativo",
      },
      columns: [
        "id",
        "nombre",
        "apellido",
        "email",
        "institucion",
        "salon",
        "experiencia_concreta",
        "observacion_reflexiva",
        "conceptualizacion_abstracta",
        "experimentacion_activa",
        "resultado_nivel_1",

        "c1_p1",
        "c1_p2",
        "c1_p3",
        "c1_p4",
        "c1_p5",

        "competencias",
        "fortaleza",
        "c2_p1",
        "c2_p2",
        "c2_p3",
        "c2_p4",
        "c2_p5",

        "campos",
        "c3_p1",
        "c3_p2",
        "c3_p3",
        "c3_p4",
        "c3_p5",
        "c3_p6",
        "c3_p7",

        "fecha_registro"
      ],
      data: null,
      options: {
        perPage: 100,
        headings: {
          id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          institucion: "Instituto",
          salon: "Salón",
          email: "Email",
          experiencia_concreta: "Experiencia Concreta",
          observacion_reflexiva: "Observación Reflexiva",
          conceptualizacion_abstracta: "Conceptualización Abstracta",
          experimentacion_activa: "Experimentación Activa",
          "c1_p1": "c1_p1",
          "c1_p2": "c1_p2",
          "c1_p3": "c1_p3",
          "c1_p4": "c1_p4",
          "c1_p5": "c1_p5",
          resultado_nivel_1: "Resultado Nivel 1",

          competencias: "Competencias",
          fortaleza: "Fortaleza",
          "c2_p1": "c2_p1",
          "c2_p2": "c2_p2",
          "c2_p3": "c2_p3",
          "c2_p4": "c2_p4",
          "c2_p5": "c2_p5",

          campos: "Campos Aptos",
          "c3_p1": "c3_p1",
          "c3_p2": "c3_p2",
          "c3_p3": "c3_p3",
          "c3_p4": "c3_p4",
          "c3_p5": "c3_p5",
          "c3_p6": "c3_p6",
          "c3_p7": "c3_p7",

          "fecha_registro": "Fecha Registro",
        },
        editableColumns: [],
        sortable: [],
      },
      columns_users: [
        "user_id",
        "nombre",
        "apellido",
        "email",
        "celular",
        "fecha_nacimiento",
        "edad",
      ],
      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
        },
        editableColumns: [],
        sortable: ["edad"],
      },
      camposObj: null,

      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.camposObj = this.$store.state.campos_conocimiento;

    this.getUsers();
    this.getCuestionarios();
  },
  methods: {
    async getCuestionarios() {
      this.$store.dispatch("showLoader", true);
      //console.log("getting misiones");
      const docs = await misionesCollection.get();

      //console.log({ misiones: docs });

      await this.getAhora();

      this.tickets = [];
      docs.forEach((doc) => {
        let ticket = doc.data();

        if (ticket.user_id == "Vu7dm3jyJlNFCiVJdLov9ze2PeI2") return;

        ticket.id = doc.id;

        try {
          ticket.nombre = this.users[ticket.user_id].nombre;
        } catch (e) {
          ticket.nombre = "";
        }

        try {
          ticket.apellido = this.users[ticket.user_id].apellido;
        } catch (e) {
          ticket.apellido = "";
        }

        try {
          ticket.email = this.users[ticket.user_id].email;
        } catch (e) {
          ticket.email = "";
        }

        try {
          ticket.institucion = this.users[ticket.user_id].institucion;
        } catch (e) {
          ticket.institucion = "";
        }

        try {
          ticket.salon = this.users[ticket.user_id].salon;
        } catch (e) {
          ticket.salon = "";
        }

        if (ticket.mision1 == null) {
          ticket.mision1 = {};
        } else {
          ticket.experiencia_concreta = ticket.mision1.habilidades.habilidad_0;
          ticket.observacion_reflexiva = ticket.mision1.habilidades.habilidad_1;
          ticket.conceptualizacion_abstracta =
            ticket.mision1.habilidades.habilidad_2;
          ticket.experimentacion_activa =
            ticket.mision1.habilidades.habilidad_3;
          ticket.resultado_nivel_1 = ticket.mision1.resultado_evaluacion;
        }
        if (ticket.mision2 == null) {
          ticket.mision2 = {};
          ticket.fortaleza = "";
        } else {
          ticket.fortaleza = this.habilidades[ticket.mision2.fortaleza];

          try {
            ticket.competencias = this.getCompetencias(
              ticket.mision2["competencias"]
            );

            //console.log({ competenciasmision2: ticket.competencias });
          } catch (e) {
            ticket.competencias = "";
          }
        }

        if (ticket.mision3 == null) {
          ticket.mision3 = {};
        } else {
          ticket.campos = this.getCampos(ticket.mision3.campos_aptos);
        }
        if (ticket.mision3 == null) {
          ticket.mision3 = {};
        }
        if (ticket.cuestionario1 == null) {
          ticket.mision1 = {};
        } else {
          ticket.c1_p1 = ticket.cuestionario1.pregunta1;
          ticket.c1_p2 = ticket.cuestionario1.pregunta2;
          ticket.c1_p3 = ticket.cuestionario1.pregunta3;
          ticket.c1_p4 = ticket.cuestionario1.pregunta4;
          ticket.c1_p5 = ticket.cuestionario1.pregunta5;
        }
        if (ticket.cuestionario2 == null) {
          ticket.cuestionario2 = {};
        } else {
          ticket.c2_p1 = ticket.cuestionario2.pregunta1;
          ticket.c2_p2 = ticket.cuestionario2.pregunta2;
          ticket.c2_p3 = ticket.cuestionario2.pregunta3;
          ticket.c2_p4 = ticket.cuestionario2.pregunta4;
          ticket.c2_p5 = ticket.cuestionario2.pregunta5;
        }
        if (ticket.cuestionario3 == null) {
          ticket.cuestionario3 = {};
        }else{
          ticket.c3_p1 = ticket.cuestionario3.pregunta1;
          ticket.c3_p2 = ticket.cuestionario3.pregunta2;
          ticket.c3_p3 = ticket.cuestionario3.pregunta3;
          ticket.c3_p4 = ticket.cuestionario3.pregunta4;
          ticket.c3_p5 = ticket.cuestionario3.pregunta5;
          ticket.c3_p6 = ticket.cuestionario3.pregunta6;
          ticket.c3_p7 = ticket.cuestionario3.pregunta7;
        }

        //console.log(ticket.created_on)
        ticket.fecha_registro = this.getFechaFormato(ticket.created_on.seconds);

        delete ticket.mision1;
        delete ticket.mision2;
        delete ticket.mision3;
        delete ticket.mision4;
        delete ticket.mision5;

        delete ticket.cuestionario1;
        delete ticket.cuestionario2;
        delete ticket.cuestionario3;
        delete ticket.id;
        delete ticket.avatar;
        
        //console.log({ ticket: ticket });

        this.tickets.push(ticket);
      });
      this.tickets = this.tickets.sort(this.custom_sort);
      //console.log({ tickets: this.tickets });

      this.setUsersArray();
      this.$store.dispatch("showLoader", false);
    },
    getCompetencias(competencias) {
      if (competencias != null) {
        let comps = Object.values(competencias);

        comps.forEach((competencia) => {
          competencia[0] = this.habilidades[competencia[0]];
        });

        return JSON.stringify(competencias);
      }

      return "";
    },
    getCampos(campos) {
      //console.log("getting campos");
      //console.log({ campos: campos });
      let campostemp = Object.values(campos);
      //console.log({ campostemp: campostemp });

      let campos_usuario = {};

      campostemp.forEach((campos_aptos) => {
        //campostemp[0] = ;
        //console.log(this.camposObj["obj" + campos_aptos.campo].nombre);
        let nombre = this.camposObj["obj" + campos_aptos.campo].nombre;
        let campos_especificos = this.camposObj["obj" + campos_aptos.campo]
          .campos_especificos;

        campos_usuario[nombre] = {};

        if (campos_usuario[nombre].campos_especificos == null) {
          campos_usuario[nombre].campos_especificos = [];
        }

        campos_especificos.forEach((campo_especifico) => {
          let carreras = campo_especifico.carreras;
          campos_usuario[nombre].campos_especificos.push(
            campo_especifico.nombre
          );
        });
      });

      //console.log({ campos_usuario: JSON.stringify(campos_usuario) });

      return JSON.stringify(campos_usuario, null, 2);
    },
    setUsersArray() {
      this.users_array = [];
      Object.keys(this.users).forEach((key) => {
        let obj = this.users[key];
        obj.user_id = key;
        obj.edad = moment().diff(obj.fecha_nacimiento, "years");
        //console.log(key, obj);
        this.users_array.push(obj);
      });
    },
    async getUsers() {
      //console.log("getting users");
      const docs = await usersCollection.get();
      //console.log({ userDocs: docs });
      this.users = {};
      docs.forEach((doc) => {
        let user = doc.data();
        //user.id = doc.id;
        //console.log(doc.id)
        this.users[doc.id] = user;
      });
      //console.log({ users: this.users });
    },
    async getUsersAuth() {
      //console.log("getting users auth");

      //fb.functions.useFunctionsEmulator('http://localhost:5000')
      let getUsersEmail = fb.functions.httpsCallable("getAllUsers");

      let users = null;
      await getUsersEmail("{}")
        .then((result) => {})
        .catch((error) => {});
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    // procesaTickets(){
    //   this.tickets_procesados = []
    //   this.tickets.forEach(ticket => {

    //   })
    // },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    procesaPuntos(puntos, monedero) {
      if (monedero == "") return puntos;

      return puntos * 2;
    },
    getNumSemana(fecha) {
      return parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;
    },
    getSemana(fecha) {
      return moment(fecha).subtract(1, "days").week();
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    async getAhora() {
      this.$store.dispatch("showLoader", true);
      var thes = this;
      //fb.functions.useFunctionsEmulator('http://localhost:5000')
      var getFecha = fb.functions.httpsCallable("getAhora");

      let res = null;
      await getFecha("{}")
        .then(function (result) {
          // Read result of the Cloud Function.
          //console.log({ resultadoGetAhora: result });
          thes.ahora = thes.getFechaFormato(result.data._seconds);
          //console.log({ahora: thes.ahora})
        })
        .catch(function (error) {
          console.log({ errorgetahora: error });
        });

      this.$store.dispatch("showLoader", false);
    },
    logout() {
      this.$store.dispatch("logoutReportes");
    },
  },
};
</script>

<style scoped>
html,
body,
#app {
  overflow: scroll !important;
}
#reportes {
  height: 100vh;
  overflow: scroll;
}
</style>
